import { useEffect, useState } from 'react';
import { Track } from '../types';
import { DEFAULT_TRACKS } from '../data/defaultTracks';

// Module-level cache so the many components that render track visuals
// (cards, badges) share a single /api/tracks request per page load.
let cachedTracks: Track[] | null = null;
let inflight: Promise<Track[]> | null = null;

const fetchTracks = async (): Promise<Track[]> => {
  try {
    const res = await fetch('/api/tracks');
    if (res.ok) {
      const data = (await res.json()) as Track[];
      if (Array.isArray(data) && data.length > 0) {
        return data;
      }
    }
  } catch (error) {
    console.error('Error fetching tracks:', error);
  }
  return DEFAULT_TRACKS;
};

export const invalidateTracksCache = (): void => {
  cachedTracks = null;
  inflight = null;
};

export const useTracks = (): Track[] => {
  const [tracks, setTracks] = useState<Track[]>(cachedTracks ?? DEFAULT_TRACKS);

  useEffect(() => {
    if (cachedTracks) return;

    if (!inflight) {
      inflight = fetchTracks().then((result) => {
        cachedTracks = result;
        return result;
      });
    }

    let mounted = true;
    inflight.then((result) => {
      if (mounted) setTracks(result);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return tracks;
};
